module.exports = __webpack_public_path__ + "static/media/cybersecurity.18e03f8e.png";